import { render, staticRenderFns } from "./DailyChatOpinion.vue?vue&type=template&id=5d361125&scoped=true"
import script from "./DailyChatOpinion.vue?vue&type=script&lang=js"
export * from "./DailyChatOpinion.vue?vue&type=script&lang=js"
import style0 from "./DailyChatOpinion.vue?vue&type=style&index=0&id=5d361125&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d361125",
  null
  
)

export default component.exports